import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import React from "react";
import { Navigate } from "react-router-dom";
import { useAppContext } from "../context/appcontext";

const ProtectedRoute = ({ element }) => {
  const { instance } = useMsal();
  let isAuthenticated = useIsAuthenticated();
   const {authChecked, setAuthChecked } = useAppContext();
  const token = localStorage.getItem("access_token");
  
  if(!isAuthenticated){
    let isauthentic = localStorage.getItem("isauthenticated");
    
    if(isauthentic == "true"){
      isAuthenticated = true
      setAuthChecked(true);
    }
      
  }
  
  
if(!authChecked || token == null || token == undefined || token == ""){
  return null;
}
  if(token == null || token == undefined || token == ""){
    instance.setActiveAccount(null);
    isAuthenticated = false;
    instance.logoutRedirect();
  }
  if (!isAuthenticated) { 
      const accounts = instance.getAllAccounts();
      if (accounts.length > 0) {
          instance.setActiveAccount(accounts[0]); 
      }    
  }
  return isAuthenticated ? authChecked && (element) : <Navigate to="/" />;
};

export default ProtectedRoute;